import { ChangeDetectionStrategy, Component, Input, ViewChild, inject } from '@angular/core';
import { Icon } from '../../common/components/general/icon/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { VehicleContext } from '../../landing-page/vehicle-search/vehicle-search-model';
import { Card } from '../../common/components/general/card/card';
import { Label } from '../../common/models/page-components';
import { ContentFilterPipe } from '../../common/pipes/content-filter-pipe';
import { COMPONENT_META_DATA } from '../../common/constants/component-meta-data';
import { AnalyticsService } from '../../common/services/analytics-service';

@Component({
  selector: 'srp-vehicle-details',
  imports: [Icon, MatMenuModule, Card,ContentFilterPipe],
  templateUrl: './vehicle-details.html',
  styleUrl: './vehicle-details.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleDetails {
  @Input() vehicleContext: VehicleContext;
  @Input() pageContentLabels: Label[];
  @ViewChild(MatMenuTrigger) menuTrigger?: MatMenuTrigger;
  LABELS=COMPONENT_META_DATA.HEADER.LABELS;
  private readonly analyticsService = inject(AnalyticsService);

  get showPrimaryVehicleCard(): boolean {
    return this.hasNonBlankValue(this.vehicleContext?.vin)
      || this.hasNonBlankValue(this.vehicleContext?.bodyWork)
      || this.hasNonBlankValue(this.vehicleContext?.cubicCapacity)
      || this.hasNonBlankValue(this.vehicleContext?.version)
      || this.hasNonBlankValue(this.vehicleContext?.engineCode)
      || this.hasNonBlankValue(this.vehicleContext?.numberOfDoors)
      || this.hasNonBlankValue(this.vehicleContext?.unLadenWeight)
      || this.hasNonBlankValue(this.vehicleContext?.tireSize);
  }

  get showSecondaryVehicleCard(): boolean {
    return this.hasNonBlankValue(this.vehicleContext?.brandDescription)
      || this.hasNonBlankValue(this.vehicleContext?.modelDescription)
      || this.hasNonBlankValue(this.vehicleContext?.energyCode)
      || this.hasNonBlankValue(this.vehicleContext?.typeOfClutch)
      || this.hasNonBlankValue(this.vehicleContext?.powerKW)
      || this.hasNonBlankValue(this.vehicleContext?.registrationDate);
  }

  get shouldShowInfoIcon(): boolean {
    return this.hasNonBlankValue(this.vehicleContext?.vin)
      || this.hasNonBlankValue(this.vehicleContext?.brandDescription);
  }

  closeCart(trigger?: { closeMenu?: () => void }): void {
    trigger?.closeMenu?.();
    this.menuTrigger?.closeMenu();
  }

  onVehicleDetailsClick(): void {
    this.analyticsService.trackClickEvent('uaevent', 'Header', 'Display::PopIn::VehicleDetails', 'Vehicle Details i icon click');
  }

  private hasNonBlankValue(value: unknown): boolean {
    if (Array.isArray(value)) {
      return value.some((entry) => typeof entry === 'string' ? entry.trim().length > 0 : !!entry);
    }

    if (typeof value === 'string') {
      return value.trim().length > 0;
    }

    return !!value;
  }


}
